module.exports = "<span class=fc-bankers-love-red-100 ng-message=required>*An Appetite Level is required</span> ";